import styled from 'styled-components';

import type { HexColor } from 'style/types';

const Root = styled.svg`
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

type Props = {
  color: HexColor;
  status?: 'problem' | 'pending' | 'checked' | 'warning';
};
export const DiamondStatus = ({ color, status }: Props) => {
  return (
    <Root width="24" height="24" viewBox="0 0 24 24" fill="none">
      {!status && (
        <g>
          <rect
            y="-1.06066"
            width="15.4706"
            height="15.4706"
            transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.25 22.1893)"
            fill={color}
            stroke="currentColor"
            fillOpacity="0.16"
            strokeWidth="1.5"
          />
        </g>
      )}
      {status === 'checked' && (
        <g>
          <rect
            y="-1.125"
            width="15.3796"
            height="15.3796"
            transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.2045 22.0795)"
            fill={color}
            stroke={color}
            strokeWidth="1.59099"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5608 9.31077L10.5001 16.3714L6.43945 12.3108L8.56077 10.1895L10.5001 12.1288L15.4395 7.18945L17.5608 9.31077Z"
            fill="#101010"
          />
        </g>
      )}
      {status === 'warning' && (
        <g>
          <rect
            y="-0.707107"
            width="15.9706"
            height="15.9706"
            transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.5 22.7929)"
            fill={color}
            stroke="currentColor"
            fillOpacity="0.16"
          />
          <rect x="11" y="7.5" width="2" height="5" fill="currentColor" />
          <rect x="11" y="14" width="2" height="2" fill="currentColor" />
        </g>
      )}
      {status === 'problem' && (
        <g>
          <rect
            width="16.9706"
            height="16.9706"
            transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 12 24)"
            fill={color}
            fillOpacity="0.16"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.87879 12.0001L6.43945 8.56077L8.56077 6.43945L12.0001 9.87879L15.4395 6.43945L17.5608 8.56077L14.1214 12.0001L17.5608 15.4395L15.4395 17.5608L12.0001 14.1214L8.56077 17.5608L6.43945 15.4395L9.87879 12.0001Z"
            fill="currentColor"
          />
        </g>
      )}
      {status === 'pending' && (
        <g>
          <rect
            width="16.9706"
            height="16.9706"
            transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 12 24)"
            fill={color}
            fillOpacity="0.16"
          />
          <path
            d="M15.125 15.75V15.3398C15.125 14.793 14.9492 14.2852 14.6172 13.8359L13.25 12L14.6172 10.1836C14.9492 9.73438 15.125 9.20703 15.125 8.67969V7C14.3245 7 8.875 7 8.875 7V8.67969C8.875 9.22656 9.03125 9.73438 9.36328 10.1836L10.75 12L9.36328 13.8359C9.03125 14.2656 8.875 14.793 8.875 15.3398V17C8.875 17 14.3191 17 15.125 17V15.75ZM10.125 15.75V15.3398C10.125 15.0664 10.2031 14.8125 10.3594 14.5977L12 12.4297L13.6211 14.5977C13.7773 14.8125 13.875 15.0664 13.875 15.3398V15.75H10.125Z"
            fill="currentColor"
          />
        </g>
      )}
    </Root>
  );
};
